import { render, staticRenderFns } from "./ErroresComponent.vue?vue&type=template&id=1be7e599"
import script from "./ErroresComponent.vue?vue&type=script&lang=js"
export * from "./ErroresComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports